import { Link } from 'react-router-dom'
import { FiArrowLeft } from 'react-icons/fi'

const LegalDocumentLayout = ({ eyebrow, title, children }) => (
  <main
    id="main-content"
    role="main"
    tabIndex={-1}
    className="w-full min-w-0 pt-24 sm:pt-28 pb-16 transition-theme"
  >
    <div className="container-custom max-w-3xl">
      <Link
        to="/"
        className="inline-flex items-center gap-2 text-sm font-semibold text-accent hover:underline focus:outline-none rounded-lg mb-8"
      >
        <FiArrowLeft className="w-4 h-4" aria-hidden />
        Voltar ao início
      </Link>

      <header className="mb-10">
        <p className="text-xs font-bold text-accent uppercase tracking-[0.2em] mb-2">{eyebrow}</p>
        <h1 className="text-2xl sm:text-3xl font-extrabold text-gray-900 dark:text-white tracking-tight">
          {title}
        </h1>
      </header>

      <article className="space-y-8 text-gray-700 dark:text-gray-300 text-sm sm:text-base leading-relaxed">
        {children}
      </article>
    </div>
  </main>
)

export default LegalDocumentLayout
